import moment from "moment";
export const filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null) {
        if (isNaN(row[id])) {
            return (
                row[id] !== undefined ?
                    String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
                    :
                    true
            );
        } else {
            return (
                row[id] !== undefined ?
                    String(row[id]).startsWith(filter.value)
                    :
                    true
            );
        }
    }
};

export const csvReader = (data) => {
    let csvData = {}
    let csvDataArray = []
    for (let i = 1; i <= data.length - 1; i++) {
        let csvRow = data[i]
        if (csvRow.length === data[0].length) {
            let csvData = Object.assign({}, csvData)
            csvRow.map((rowValue, j) => {
                csvData[data[0][j]] = rowValue
            })
            csvDataArray.push(csvData)
        }
    }
    return csvDataArray;
};

export const getRendomNumber = (length) => {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const formatDateNew = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
    }).format(amount);
};

export const formatDateLatest = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    });
};




export const formatDate = (date) => {
    var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
};

export const reverseFormat = (date) => {
    var d = date.split("-");

    return [d[2], d[1], d[0]].join("-");
};
export const subtractOneDay = (dateString) => {
    const dateParts = dateString.split("-");

    // Convert DD-MM-YYYY to a Date object
    const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);

    // Subtract one day
    formattedDate.setDate(formattedDate.getDate() - 1);

    // Convert back to DD-MM-YYYY format
    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0");
    const year = formattedDate.getFullYear();

    return `${day}-${month}-${year}`; // Return in DD-MM-YYYY format
};



export const todayDate = () => {
    var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
};
export const monthStartDate = () => {
    var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + 1,
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
};
export const monthLastDate = () => {
    var today = new Date();
    // var date = `today.getFullYear(), today.getMonth()+1, 0`;
    var d = new Date(today.getFullYear(), today.getMonth() + 1, 0),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
};

export const lastDateOfMonth = (date) => {

    return moment(new Date(date)).endOf('month').format("DD-MM-YYYY");
}
export const firstDateOfMonth = (date) => {
    return moment(new Date(date)).startOf('month').format('DD-MM-YYYY');
};

export const getStartDateOfPreviousSevenDays = (date) => {
    return moment(date).subtract(6, 'days').startOf('day').format('DD-MM-YYYY');
};
